import type { LandingPageBlock } from '@provision/landing-page-utils';

export type MediaBlock = Extract<LandingPageBlock, { type: 'hero' | 'content' }>;

export function blockImageUrl(block: MediaBlock): string | undefined {
  return (block.type === 'hero' ? block.image?.url : block.imageUrl)?.trim() || undefined;
}

/** True when the block shows media, so it can lay out a column for it. */
export function hasBlockMedia(block: MediaBlock): boolean {
  return (
    block.mediaKind === 'video' ||
    (block.mediaKind === 'image' && blockImageUrl(block) !== undefined)
  );
}
